import { t as translateDate } from './translate-date.js';
import './index2.js';

/*
 * Prestige Soft
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_85
       * @see {@link boot}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        const container = document.querySelector('#id_container') || document.querySelector('#PSBookEngine');
        if (container) {
            let refreshPage = thn.debounce(() => {
                const loader = document.querySelector('#id_mw_head');
                if (!loader) {
                    thn.pageCheck();
                }
            }, 250);
            thn.observeDom(container, refreshPage, {
                childList: true,
                subtree: false,
                attributes: false,
            });
            thn.shutdown(function () {
                refreshPage.cancel();
                thn.stopObserveDom(container, refreshPage);
                refreshPage = null;
            });
        }
    };
    thn.domReady().then(function () {
        const framedDocument = window.psFrameDocument;
        if (framedDocument) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://www.thehotelsnetwork.com/js/loader.js?property_id=${thn.data.propertyId}`;
            script.defer = 'defer';
            framedDocument.head.appendChild(script);
        }
    });
    /**
       * @memberOf module:bs_85
       * @this thn.widgets.price
       * @see {@link languageCheck}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let aux = thn.parseUrlParameter('idiomaid');
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            thn.domReady().then(function () {
                aux = ctx.getHtmlLang();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                resolve('es');
            });
        });
    };
    /**
     * @memberOf module:bs_85
     * @this thn.widgets.price
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
    engine.getPromocode = function getPromocode(ctx) {
        const promocodeEl = document.querySelector('#id_ed_promo');
        if (promocodeEl && promocodeEl.value) {
            ctx.promocode = promocodeEl.value;
        }
        return ctx.promocode;
    };
    /**
         * @memberOf module:bs_85
         * @this thn.widgets.price
         * @see {@link Price#observe_dom}
         *
         * @param {object} ctx - The context object.
         */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('#id_main_cont_general');
        if (container) {
            let refreshPrice = thn.debounce(() => {
                const loader = document.querySelector('#id_mw_head');
                if (!loader) {
                    thn.widgets.price.refresh();
                }
            }, 250);
            thn.observeDom(container, refreshPrice, {
                childList: true,
                subtree: true,
                attributes: false,
                characterData: true,
            });
            thn.pageUnload(function () {
                refreshPrice.cancel();
                thn.stopObserveDom(container, refreshPrice);
                refreshPrice = null;
            });
        }
    };
    /**
       * @memberOf module:bs_85
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        if (!document.querySelector('#id_frm_vw_step1')) {
            return widgetData;
        }
        const items = ((((window.CHM || {}).app || {}).controllers || {}).vw_step1 || {}).items || {};
        // Dates
        const dateBegin = (items.desdeSelected && thn.dateToString(items.desdeSelected))
            || translateDate((document.querySelector('#id_ed_desde') || {}).textContent || '', thn.data.language);
        const dateEnd = (items.hastaSelected && thn.dateToString(items.hastaSelected))
            || translateDate((document.querySelector('#id_ed_hasta') || {}).textContent || '', thn.data.language);
        let nights;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        const guests = items.cestaItemSelected || {};
        widgetData.adults = guests.adultos
            || thn.parseNumber((document.querySelector('#id_ed_adults_0') || {}).textContent) || 2;
        widgetData.children = guests.nenes
            || thn.parseNumber((document.querySelector('#id_ed_children_0') || {}).textContent) || 0;
        const babies = guests.bebes
            || thn.parseNumber((document.querySelector('#id_ed_infants_0') || {}).textContent) || 0;
        widgetData.children += babies;
        if (widgetData.children) {
            const room1Info = {
                adults: widgetData.adults,
                children: widgetData.children,
                childrenAges: [],
            };
            for (let i = 1; i <= widgetData.children; i += 1) {
                room1Info.childrenAges.push(i <= widgetData.children - babies ? guests[`child${i}`] : 0);
            }
            widgetData.roomsDispo = [room1Info];
        }
        // Prices & Currency || No Rooms
        const prices = [...document.querySelectorAll('.fw_be_habitacion_precio, .fw_be_habitacion_precio_oferta')]
            .map((el) => thn.parseNumber(el.textContent))
            .filter((price) => price);
        widgetData.currency = (items.currentCurrency || {}).currencyISO
            || (document.querySelector('#id_hab_showcmb') || {}).textContent;
        // ZT Hoteles
        const isPricePerNight = thn.inArray(thn.data.accountUserId, [1040143]);
        if (prices && prices.length) {
            widgetData.price = isPricePerNight ? (Math.min(...prices) / nights).toFixed(2) : Math.min(...prices);
        }
        if (widgetData.currency && widgetData.price) {
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_85
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const booking = ((((window.CHM || {}).app || {}).controllers || {}).vw_step4 || {}).items || {};
        widgetData.bookingId = booking.localizador || (document.querySelector('.fw_be_conf_number') || {}).textContent;
        widgetData.dateBegin = booking.desdeSelected && thn.dateToString(booking.desdeSelected);
        widgetData.dateEnd = booking.hastaSelected && thn.dateToString(booking.hastaSelected);
        widgetData.price = thn.parseNumber(booking.cestaTotal || (document.querySelector('.fw_be_confirmation_grand_precio') || {}).textContent);
        widgetData.currency = (booking.currentCurrency || {}).currencyISO || (((document.querySelector('.fw_be_confirmation_grand_precio') || {}).textContent || '').match(/[A-Z]{3}/) || [])[0];
        return widgetData;
    };
    return engine;
}

export { factory };
